import { CurrencyPipe } from '@angular/common';
import { Pipe, type PipeTransform } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../services/storage.service';
import { StorageEnum } from '../enums/storage.enum';
import { AccountDetail } from '../models/account-detail';

@Pipe({
  name: 'perTherm',
  standalone: true,
})
export class PerThermPipe implements PipeTransform {
  accountDetail: AccountDetail = new AccountDetail();

  constructor(private readonly storage: StorageService) {}

  transform(value: string, ...args: any[]): string {
    this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
    let customerClass: string | undefined = 'RES';
    if (this.accountDetail) {
      customerClass = this.accountDetail.CustomerClass;
    }
    const val = parseFloat(value);
    const sup = args.length > 0 ? args[0] : false;

    // return passed value if isNaN
    if (isNaN(val) || val < 0) {
      return value;
    }

    const currencyPipe = new CurrencyPipe('en-US');

    const currencyArray = !val.toString().includes('.')
      ? (val?.toFixed(2).toString().split('.') as any)
      : (val?.toString().split('.') as any);
    let [dollars, cents] =
      parseInt(currencyArray[1]) > 0 && currencyArray[1].length > 2
        ? (val?.toString().split('.') as any)
        : (currencyPipe.transform(val)?.split('.') as any);
    dollars = dollars.replace('$', '');

    const pDollars = parseInt(dollars, 10);
    const pCents = parseFloat(cents);
    const dollarSign = sup ? '<sup class="sup-therm">$</sup>' : '$';
    const centSign = sup ? '<sup class="sup-therm">¢</sup>' : '¢';

    if (customerClass !== 'RES') {
      if (pDollars >= 1) {
        if (pCents > 0) {
          return `${currencyPipe.transform(val, 'en-US', dollarSign, '1.2-4')}`;
        } else {
          return `${dollarSign}${val}`;
        }
      } else {
        if (pCents > 0) {
          if (pCents.toString().length === 2) {
            return `${pCents}${centSign}`;
          } else {
            return `${currencyPipe.transform(val, 'en-US', dollarSign, '1.2-4')}`;
          }
        } else {
          return `0${centSign}`;
        }
      }
    } else {
      if (pDollars >= 1) {
        if (pCents > 0) {
          const decimalPlaces = val.toString();
          if (decimalPlaces.split('.')[1].length > 2) {
            return `${currencyPipe.transform(val, 'en-US', dollarSign, '1.2-4')}`;
          } else {
            return `${dollarSign}${val.toFixed(2)}`;
          }
        } else {
          return `${dollarSign}${val}`;
        }
      } else {
        if (pCents > 0) {
          const decimalPlaces = val.toString();
          if (decimalPlaces.split('.')[1].length > 2) {
            return `${currencyPipe.transform(val, 'en-US', dollarSign, '1.2-4')}`;
          } else {
            return `${pCents}${centSign}`;
          }
        } else {
          return `0${centSign}`;
        }
      }
    }
  }
}
